import { FC } from 'react';
import { Link } from 'react-router-dom';
import { DropDownSVG, MarketPlaceSVG } from '../../../svgs';
import { redirectToTopOfThePage } from '../../../../utils/commonUtils';
import { MARKETPLACE_MANAGEMENT_PATHS, APP_PATHS } from '../../../../constants/routePaths';
import { NAVIGATION_LINK_CONSTANTS } from '../../../../constants/common';

type MarketplaceManagementLinksProps = {
  currentRoute: string[];
  showMarketplaceManagementPages: boolean;
  setShowMarketplaceManagementPages: React.Dispatch<React.SetStateAction<boolean>>;
  setOpen: React.Dispatch<React.SetStateAction<boolean>>;
  setOpenNavBar: React.Dispatch<React.SetStateAction<boolean>>;
};

const MarketplaceManagementLinks: FC<MarketplaceManagementLinksProps> = ({
  currentRoute,
  showMarketplaceManagementPages,
  setShowMarketplaceManagementPages,
  setOpen,
  setOpenNavBar,
}) => {
  const activeLinkClass = (path: string) => {
    return currentRoute.includes(path) ? 'nav-link active' : 'nav-link';
  };

  const activeSubLinkClass = (path: string) => {
    return currentRoute.includes(path) ? 'nav-sub-link active' : 'nav-sub-link';
  };

  const closeSideBar = () => {
    setOpen(false);
    setOpenNavBar(false);
    redirectToTopOfThePage();
  };

  return (
    <div>
      <button
        type="button"
        className={activeLinkClass(APP_PATHS.MARKETPLACE_MANAGEMENT)}
        onClick={() => setShowMarketplaceManagementPages(!showMarketplaceManagementPages)}>
        <MarketPlaceSVG />
        {NAVIGATION_LINK_CONSTANTS.MARKETPLACE_MANAGEMENT}
        <DropDownSVG reversed={showMarketplaceManagementPages} />
      </button>
      {showMarketplaceManagementPages && (
        <div>
          <Link
            className={activeSubLinkClass(MARKETPLACE_MANAGEMENT_PATHS.LISTING)}
            to={APP_PATHS.MARKETPLACE_MANAGEMENT_ + MARKETPLACE_MANAGEMENT_PATHS.LISTING}
            onClick={closeSideBar}>
            {NAVIGATION_LINK_CONSTANTS.LISTING}
          </Link>
          <Link
            className={activeSubLinkClass(MARKETPLACE_MANAGEMENT_PATHS.COMMISSION_REPORT)}
            to={APP_PATHS.MARKETPLACE_MANAGEMENT_ + MARKETPLACE_MANAGEMENT_PATHS.COMMISSION_REPORT}
            onClick={closeSideBar}>
            {NAVIGATION_LINK_CONSTANTS.COMMISSION_REPORT}
          </Link>
          <Link
            className={activeSubLinkClass(MARKETPLACE_MANAGEMENT_PATHS.BREEDER_PAYMENTS)}
            to={APP_PATHS.MARKETPLACE_MANAGEMENT_ + MARKETPLACE_MANAGEMENT_PATHS.BREEDER_PAYMENTS}
            onClick={closeSideBar}>
            {NAVIGATION_LINK_CONSTANTS.BREEDER_PAYMENTS}
          </Link>
          <Link
            className={activeSubLinkClass(MARKETPLACE_MANAGEMENT_PATHS.SETTINGS)}
            to={APP_PATHS.MARKETPLACE_MANAGEMENT_ + MARKETPLACE_MANAGEMENT_PATHS.SETTINGS}
            onClick={closeSideBar}>
            {NAVIGATION_LINK_CONSTANTS.MARKETPLACE_SETTINGS}
          </Link>
        </div>
      )}
    </div>
  );
};

export default MarketplaceManagementLinks;
